import React from 'react';

import { AlertOctagon } from 'react-feather';
import { useIntl } from 'react-intl';

// import LogoutButton from '../../../containers/LogoutButton';
import messages from '../messages';
import styles from '../States.module.scss';

const InitializationError = () => {
  const intl = useIntl();

  return (
    <div className={styles.wrap}>
      <AlertOctagon className={`${styles.icon} ${styles.iconError}`} size={40} />
      <p className={styles.text}>{intl.formatMessage(messages.initializeErrorMessage)}</p>
      
    </div>
  );
};

export default InitializationError;
